import React from 'react';
import { customerUploadMediaUrl } from '../productMediaUtils';
import { formatCharCustomizationLabel, normalizePersonalizationLetter } from '../productPersonalization';
import AdminCustomerPhotoBlock from './AdminCustomerPhotoBlock';
import {
  describeJewelryCustomization,
  orderItemHasCustomization,
  orderHasWorkshopPhotos,
} from './jewelryCustomization';

export { orderItemHasCustomization, orderHasWorkshopPhotos };

/**
 * Admin order customization — field breakdown, photo preview, download, and print.
 */
export default function AdminOrderCustomizationDetails({
  raw,
  productName = '',
  orderNumber = '',
  compact = false,
}) {
  const text = String(raw || '').trim();
  if (!text) {
    return compact ? <span className="text-muted">—</span> : null;
  }

  const jewelry = describeJewelryCustomization(text);
  if (jewelry) {
    if (compact) {
      return (
        <div className="admin-order-custom admin-order-custom--compact">
          <span className="admin-order-custom__type">{jewelry.profileLabel}</span>
          <ul className="admin-order-custom__fields list-unstyled mb-0">
            {jewelry.fields.map((f) => (
              <li key={f.id} className="admin-order-custom__field">
                {f.type === 'photo' && f.photoUrl ? (
                  <span className="admin-order-custom__photo-row">
                    <img
                      src={customerUploadMediaUrl(f.photoUrl)}
                      alt=""
                      className="admin-order-custom__thumb"
                    />
                    <span>{f.label}</span>
                  </span>
                ) : (
                  <span>
                    <strong>{f.label}:</strong> {f.value}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      );
    }

    return (
      <div className="admin-order-custom">
        <p className="admin-order-custom__summary mb-2">
          <strong>{jewelry.profileLabel}</strong>
          {jewelry.summary && jewelry.summary !== jewelry.profileLabel ? (
            <span className="text-muted"> — {jewelry.summary}</span>
          ) : null}
        </p>
        <dl className="admin-order-custom__dl mb-0">
          {jewelry.fields.map((f) => (
            <div key={f.id} className="admin-order-custom__row">
              <dt>{f.label}</dt>
              <dd>
                {f.type === 'photo' && f.photoUrl ? (
                  <AdminCustomerPhotoBlock
                    url={f.photoUrl}
                    label={f.label}
                    filePrefix={`${orderNumber}-${productName}`}
                  />
                ) : (
                  f.value
                )}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    );
  }

  const letter = normalizePersonalizationLetter(text);
  const label = letter ? formatCharCustomizationLabel(letter) : text;

  return (
    <span className={compact ? 'admin-order-custom admin-order-custom--compact' : 'admin-order-custom'}>
      {label}
    </span>
  );
}
